import { render } from "./OnTrial.vue?vue&type=template&id=3f72a18c&scoped=true"
const script = {}

import "./OnTrial.vue?vue&type=style&index=0&id=3f72a18c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f72a18c"]])

export default __exports__